var map = {
	"./": "5d81",
	"./actions": "2477",
	"./actions.js": "2477",
	"./avalanche": "8d45",
	"./avalanche/": "8d45",
	"./avalanche/constants": "2aa6",
	"./avalanche/constants.js": "2aa6",
	"./avalanche/index": "8d45",
	"./avalanche/index.js": "8d45",
	"./avalanche/pendle": "e1f7",
	"./avalanche/pendle.js": "e1f7",
	"./avalanche/qiavax": "fc35",
	"./avalanche/qiavax.js": "fc35",
	"./avalanche/qiusdc": "a9b3",
	"./avalanche/qiusdc.js": "a9b3",
	"./avalanche/wonderland": "9314",
	"./avalanche/wonderland.js": "9314",
	"./avalanche/xjoe": "7066",
	"./avalanche/xjoe.js": "7066",
	"./index": "5d81",
	"./index.js": "5d81",
	"./local": "a8e2",
	"./local/": "a8e2",
	"./local/index": "a8e2",
	"./local/index.js": "a8e2",
	"./mainnet": "9c2c",
	"./mainnet/": "9c2c",
	"./mainnet/index": "9c2c",
	"./mainnet/index.js": "9c2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff82";